import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PhoneModel} from "../../entity/phone.model";

@Component({
  selector: 'app-phone-label',
  templateUrl: './phone-label.component.html'
})
export class PhoneLabelComponent implements OnInit, OnChanges {

  @Input() phone: PhoneModel;
    formattedNumber: string;

  constructor() { }

  ngOnInit() {}

    ngOnChanges(changes: SimpleChanges): void {
        this.formattedNumber = '';
        // // console.logByType['phone', this.phone]);
        if (this.phone?.fullNumber) {
            this.formattedNumber = this.phone?.fullNumber.replace(/\D/g, '');
    }
  }
}
